export default "__VITE_ASSET__DLDMLMJp__"